import type { TFunction } from 'i18next';

/** A stored name that already carries the title ("Dr. Ahmed", "د. أحمد"). */
const HAS_TITLE = /^(dr\.?|د\.)\s*/i;

/**
 * "Dr. {name}" in the reader's language. Staff names are free text and some
 * were saved with the title already, which printed "Dr. Dr. Ahmed Hassan";
 * those are shown as typed.
 */
export function formatDoctorName(
  name: string | null | undefined,
  t: TFunction,
): string {
  const trimmed = (name ?? '').trim();
  if (!trimmed) return '';
  return HAS_TITLE.test(trimmed)
    ? trimmed
    : t('common.doctorName', { name: trimmed });
}
